module.exports = __webpack_public_path__ + "b78f7901b53ddf684f450f0065dad0f5.jpg";